import { Route, Routes } from "react-router-dom";
import LoginPagePartner from "./PartnerPortal/LoginPartner/LoginPagePartner";
import ForgetPasswordPartner from "./PartnerPortal/LoginPartner/ForgetPasswordPartner";
import CreatePasswordPartner from "./PartnerPortal/LoginPartner/CreatePasswordPartner";
import SignupPagePartner from "./PartnerPortal/SignupPagePartner";
import PANDetailPagePartner from "./PartnerPortal/PANDetailPagePartner";
import AddressPagePartner from "./PartnerPortal/AddressPagePartner";
import BankDetailsPartner from "./PartnerPortal/BankDetailsPartner";
import DocumentsUploadPartner from "./PartnerPortal/DocumentsUploadPartner";
import SelectDocumentsPartner from "./PartnerPortal/SelectDocumentsPartner";
import EsignPagePartner from "./PartnerPortal/EsignPartner/EsignPagePartner";
import Blank from "./CommonMethods/BlankPage";
import SelfieUpload from "./PartnerPortal/SelfieUpload";

function Routings(){

    return(
        <>
        <Routes>
            <Route exact path="/partner" element={<SignupPagePartner />}></Route>
            <Route exact path="*" element={<Blank />}></Route>
            <Route exact path="/partner/basic-details" element={<PANDetailPagePartner />}></Route>
            <Route exact path="/partner/document-upload" element={<DocumentsUploadPartner />}></Route>

            {/* <Route exact path="/partner/address-details" element={<AddressPagePartner />}></Route> */}
            <Route exact path="/partner/bank-details" element={<BankDetailsPartner />}></Route>
            <Route exact path="/partner/selfie-upload" element={<SelfieUpload />}></Route>
            {/* <Route exact path="/partner/select-documents" element={<SelectDocumentsPartner />}></Route> */}
            <Route exact path="/partner/e-sign" element={<EsignPagePartner />}></Route>
          </Routes>
        </>
    )

}

export default Routings;